import React from "react";

import Icon, { type IconProps } from "@/components/icon";
import { Counter } from "@/components/ui";

interface IconWithCounterProps extends React.HTMLAttributes<HTMLDivElement> {
  count: number;
  countMax?: number;
  icon?: string;
  src?: string;
}

const IconWithCounter: React.FC<IconWithCounterProps> = ({
  icon,
  count,
  countMax,
  ...rest
}) => {
  return (
    <div className="relative">
      <Icon id={icon} {...(rest as IconProps)} />

      {count > 0 && (
        <span className="absolute -top-2 -right-3">
          <Counter count={count} countMax={countMax} />
        </span>
      )}
    </div>
  );
};

export default IconWithCounter;
